import React from 'react';
import Button from '@material-ui/core/Button';

/**
 * Primary CTA for PDF download links (@react-pdf PDFDownloadLink renders an anchor).
 * Use `component="span"` so we do not nest interactive <button> inside <a>.
 */
export default function PdfPrimaryDownloadButton({ children = 'Download Now', disabled, ...rest }) {
  return (
    <Button
      type="button"
      variant="contained"
      color="primary"
      component="span"
      disableElevation
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}
